import "./styles/TooltipContrastV2.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/components/ArtworkUpload.css";
import "@/salesOpsTerminology";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
